export default "__VITE_ASSET__DthcRpk3__"